import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ProjectApi } from '../../../api/ProjectApi';
import { useContainer } from '../../useContainer';
import { ActivityFeedWithUserDto } from '../../../commonTypes/project.types';
import { setCachedActivityFeedByClient, selectCachedActivityFeedByClient } from '../../../store/slices/projects.slice';

const useHttpGetActivityFeedByClientId = (clientId?: string) => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const dispatch = useDispatch();
    const cachedData = useSelector(selectCachedActivityFeedByClient(clientId || ''));
    const [activityFeed, setActivityFeed] = useState<ActivityFeedWithUserDto>();
    const [isActivityFeedReady, setIsActivityFeedReady] = useState<boolean>(false);

    const exec = (forceRefresh = false) => {
        if (clientId) {
            if (!forceRefresh && cachedData) {
                setActivityFeed(cachedData);
                setIsActivityFeedReady(true);
                return;
            }

            const { exec, abort } = projectApi.getActivityFeedByClientId({
                params: { clientId },
                onSuccess: res => {
                    dispatch(setCachedActivityFeedByClient({ clientId, data: res.body }));
                    setActivityFeed(res.body);
                },
                onError: error => console.log(error),
                onFinally: () => setIsActivityFeedReady(true),
            });
            exec();
            return abort;
        }
    };

    useEffect(() => {
        if (clientId) {
            if (cachedData) {
                setActivityFeed(cachedData);
                setIsActivityFeedReady(true);
                return;
            }

            exec();
        }
    }, [clientId]);

    return { activityFeed, isActivityFeedReady, exec };
};

export default useHttpGetActivityFeedByClientId;
